import { createApp, ref } from 'vue/dist/vue.esm-bundler.js'
import App from './App.vue'

const app = createApp({
  components: {
    App
  },
  methods: {


  },
  mounted() {
    //console.log(configurator);
    
  },
  template: `<App 
  />`
});

if(document.querySelector('#app')) {
    app.mount('#app');

}


